export function applyHomologationBoot({
    prev = {},
    empresaId,
    situacaoId = null,
    versaoFront = '',
    versaoBack = '',
    hoje = new Date(),
}) {
    const dataISO = hoje instanceof Date ? hoje.toISOString().substring(0, 10) : hoje;

    return {
        ...prev,

        ativo: prev?.ativo ?? true,

        descricao: prev?.descricao ?? '',
        objetivo: prev?.objetivo ?? '',

        data: prev?.data ?? dataISO,
        dataInicio: prev?.dataInicio ?? dataISO,
        dataFim: prev?.dataFim ?? '',

        versaoFront: prev?.versaoFront ?? versaoFront,
        versaoBack: prev?.versaoBack ?? versaoBack,

        empresaId: prev?.empresaId ?? empresaId ?? '',
        situacaoId: prev?.situacaoId ?? situacaoId ?? '',
    };
}
